
// import React, { useState, useEffect } from 'react';
// import './App.css';
// import { Routes, Route, useNavigate, useLocation } from 'react-router-dom';

// import Dashboard from './Pages/Dashboard/dashboard';
// import Home0 from './Pages/HOME/home0';
// import Dheader from './components/DHeader/dheader';
// import Member from './Pages/Member/member';
// import GeneralUser from './Pages/GeneralUser/generaluser';
// import Memberdetail from './Pages/MemberDetail/memberdetail';
// import Payment from './components/payment';
// import ProtectedRoute from './routes/ProtectedRoute';

// import axios from "axios";

// import PrivacyPolicy from "./Pages/PrivacyPolicy";
// import RefundPolicy from "./Pages/RefundPolicy";
// import TermsAndConditions from "./Pages/TermsAndConditions";

// // Always send cookies
// axios.defaults.withCredentials = true;

// export default function App() {
//  const navigate = useNavigate();
//  const location = useLocation();

//   const [isLogin, setIsLogin] = useState(false);
//   const [loading, setLoading] = useState(true);

//   // ✅ Proper login check on app load
//   useEffect(() => {
//     const checkLogin = async () => {
//       try {
//         const res = await axios.get(
//           `${process.env.REACT_APP_FRONTEND_URL}/auth/check-auth`
//         );

//         setIsLogin(res.data.success);

//       } catch (err) {
//         setIsLogin(false);
//       } finally {
//         setLoading(false);
//       }
//     };

//     checkLogin();
//   }, []);



//   // // ✅ instant login update
//   // const handleLoginSuccess = () => {
//   //   setIsLogin(true);
//   // };

//   // // ✅ logout
//   // const handleLogout = () => {
//   //   setIsLogin(false);
//   //   localStorage.clear();
//   // };



//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   return (
//     <div className='AppMain-box'>

//       {/* {isLogin && <Dheader />} */}
// {/* {isLogin && location.pathname !== "/payment" && <Dheader handleLogout={handleLogout} />} */}
// {isLogin && location.pathname !== "/payment" && <Dheader />}
//       <Routes>

//         {/* Public Route */}
//         {/* <Route path='/' element={<Home0 onLoginSuccess={handleLoginSuccess} />} /> */}
//         <Route path='/' element={<Home0  />} />
//         <Route path='/payment' element={<Payment />} />

//         {/* Protected Routes */}
//         <Route 
//           path='/dashboard' 
//           element={
//             <ProtectedRoute isLogin={isLogin}>
//               <Dashboard />
//             </ProtectedRoute>
//           } 
//         />

//         <Route 
//           path='/member' 
//           element={
//             <ProtectedRoute isLogin={isLogin}>
//               <Member />
//             </ProtectedRoute>
//           } 
//         />

//         <Route 
//           path='/specific/:page' 
//           element={
//             <ProtectedRoute isLogin={isLogin}>
//               <GeneralUser />
//             </ProtectedRoute>
//           } 
//         />

//         <Route 
//           path='/member/:id' 
//           element={
//             <ProtectedRoute isLogin={isLogin}>
//               <Memberdetail />
//             </ProtectedRoute>
//           } 
//         />

//        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
// <Route path="/refund-policy" element={<RefundPolicy />} />
// <Route path="/terms-and-conditions" element={<TermsAndConditions />} /> 

//       </Routes>

//     </div>
//   );
// }


import React, { useState, useEffect } from 'react';
import './App.css';
import { Routes, Route, useLocation } from 'react-router-dom';

import Dashboard from './Pages/Dashboard/dashboard';
import Home0 from './Pages/HOME/home0';
import Dheader from './components/DHeader/dheader';
import Member from './Pages/Member/member';
import GeneralUser from './Pages/GeneralUser/generaluser';
import Memberdetail from './Pages/MemberDetail/memberdetail';
import Payment from './components/payment';
import ProtectedRoute from './routes/ProtectedRoute';

import axios from "axios";

import PrivacyPolicy from "./Pages/PrivacyPolicy";
import RefundPolicy from "./Pages/RefundPolicy";
import TermsAndConditions from "./Pages/TermsAndConditions";

axios.defaults.withCredentials = true;

export default function App() {

  const location = useLocation();

  const [isLogin, setIsLogin] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {

    const checkLogin = async () => {

      try {

        const res = await axios.get(
          `${process.env.REACT_APP_FRONTEND_URL}/auth/check-auth`
        );

        setIsLogin(res.data.success);

      } catch (err) {

        setIsLogin(false);

      } finally {

        setLoading(false);

      }
    };

    checkLogin();

  }, []);

  // ✅ instant login update
  const handleLoginSuccess = () => {
    setIsLogin(true);
  };

  // ✅ logout
  const handleLogout = () => {
    setIsLogin(false);
    localStorage.clear();
  };

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <div className='AppMain-box'>

      {
        isLogin &&
        location.pathname !== "/payment" && (
          <Dheader handleLogout={handleLogout} />
        )
      }

      <Routes>

        {/* Public */}

        <Route
          path='/'
          element={
            <Home0
              onLoginSuccess={handleLoginSuccess}
            />
          }
        />

        <Route
          path='/payment'
          element={<Payment />}
        />

        {/* Protected */}

        <Route
          path='/dashboard'
          element={
            <ProtectedRoute isLogin={isLogin}>
              <Dashboard />
            </ProtectedRoute>
          }
        />

        <Route
          path='/member'
          element={
            <ProtectedRoute isLogin={isLogin}>
              <Member />
            </ProtectedRoute>
          }
        />

        <Route
          path='/specific/:page'
          element={
            <ProtectedRoute isLogin={isLogin}>
              <GeneralUser />
            </ProtectedRoute>
          }
        />

        <Route
          path='/member/:id'
          element={
            <ProtectedRoute isLogin={isLogin}>
              <Memberdetail />
            </ProtectedRoute>
          }
        />

        {/* Policies */}

        <Route
          path="/privacy-policy"
          element={<PrivacyPolicy />}
        />

        <Route
          path="/refund-policy"
          element={<RefundPolicy />}
        />

        <Route
          path="/terms-and-conditions"
          element={<TermsAndConditions />}
        />

      </Routes>

    </div>
  );
}